module.exports = __webpack_public_path__ + "38861cba61c66739c1452c3a71e39852.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/core/public/Roboto.ttf
// module id = 110
// module chunks = 0